import React from "react";
import "../styles/SubscriptionPage.css";
import subicon from "../Assets/imgs/subscription_icon.webp";
import warningicon from "../Assets/imgs/warning-icon.webp";
import noteicon from "../Assets/imgs/note-icon.webp";
import Header from "../components/Header";
import Footer from "../components/Footer";
import successicon from "../Assets/imgs/success-icon.webp";

// import subscbg from '../Assets/imgs/subscription-bg.webp'
type Props = {
  isSubscribe: boolean;
  handleLogout: () => void;
  handleUnSubscribe: () => void;
  loader: boolean;
  jwtToken: string | null;
  errorMsg: string;
  closeModal: () => void;
  packageList: any;
  isModalOpen: boolean;
  isModalOpenSuccess: boolean;
  closeModalSuccess: () => void;
  onHandleChangePackage: (index: number) => Promise<void>;
};

const SubscriptionPage = (props: Props) => {
  return (
    <>
      {/* header */}
      <Header
        isSubscribe={props.isSubscribe}
        loader={props.loader}
        handleLogout={() => props.handleLogout()}
        handleUnSubscribe={() => props.handleUnSubscribe()}
        errorMsg={props.errorMsg}
      />

      {/* subscription page */}
      <div className="subsc-page">
        <div className="container">
          {/* <div className='row'> */}

          <div className="subsc-bg">
            <div className="col-md-12 md-12">
              <div className="subsc-inner">
                <div className="heading">Subscription Plans</div>

                <div className="para">
                  Unlock exclusive perks and enjoy premium JobUp with our daily,
                  weekly & monthly subscription plans.
                </div>
              </div>
            </div>

            <div className="row">
              {props.packageList.map((e: any) => {
                return (
                  <div className="col-md-4 md-12">
                    <div className="subsc-card">
                      <div className="image">
                        <img src={subicon} />
                      </div>
                      <div className="plan">{e.type} PLAN</div>
                      <div className="price">
                        {e.priceText}
                      </div>
                      <div className="sub-text">{e.title}</div>
                      {e.status ? (
                        <div className="sub-btn">Subscribed</div>
                      ) : (
                        <button
                          onClick={() => props.onHandleChangePackage(e.id)}
                          className="d-button"
                        >
                          Subscribe
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}

              {/* <div className="col-md-4 md-12">
                <div className="subsc-card">
                  <div className="image">
                    <img src={subicon} />
                  </div>
                  <div className="plan">Weekly Plan</div>
                  <div className="price">
                    PKR 30+T<span>/Week</span>
                  </div>
                  <div className="sub-text">Weekly Package</div>
                  {packageList[1]?.status ? (
                    <div className="sub-btn">Subscribed</div>
                  ) : (
                    <button
                      onClick={() => onHandleChangePackage(2)}
                      className="d-button"
                    >
                      Subscribe
                    </button>
                  )}
                </div>
              </div>

              <div className="col-md-4 md-12">
                <div className="subsc-card">
                  <div className="image">
                    <img src={subicon} />
                  </div>
                  <div className="plan">Monthly Plan</div>
                  <div className="price">
                    PKR 100+T<span>/Month</span>
                  </div>
                  <div className="sub-text">Monthly Package</div>

                  {packageList[2]?.status ? (
                    <div className="sub-btn">Subscribed</div>
                  ) : (
                    <button
                      onClick={() => onHandleChangePackage(3)}
                      className="d-button"
                    >
                      Subscribe
                    </button>
                  )}
                </div>
              </div> */}
            </div>
            <div className="subcr-footer">
              <div className="col-md-12 md-12">
                <div className="footer-text">
                  <div className="image">
                    <img src={noteicon} />
                  </div>
                  <div className="text">
                    To change package, you will be unsubscribe from current
                    package plan and then will be subscribe in new package plan
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div></div>

          {/* </div> */}
        </div>
      </div>
      {/* modal */}
      <div>
        {props.isModalOpen && (
          <div className="sub-modal-overlay" onClick={props.closeModal}>
            <div
              className="sub-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <span className="sub-modal-close" onClick={props.closeModal}>
                X
              </span>
              <img src={warningicon} alt="warning" className="warning-img" />
              <p className="warning-text">
                {/* Unable to subscribe. Please try again later. */}
                Your request is in proccess
              </p>
            </div>
          </div>
        )}
      </div>
      {/* modal */}
      {/* success modal     */}
      <div>
        {props.isModalOpenSuccess && (
          <div className="success-modal-overlay">
            <div
              className="success-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <img src={successicon} alt="warning" className="success-icon" />
              <p className="congratulatiion">Congratulation </p>
              <p className="warning-text">
                {/* Unable to subscribe. Please try again later. */}
                You've successfully purchased a subscription plan.
              </p>
              <button
                className="success-button"
                onClick={props.closeModalSuccess}
              >
                Continue
              </button>
            </div>
          </div>
        )}
      </div>
      {/* success modal     */}

      <Footer />
    </>
  );
};

export default SubscriptionPage;
